import { FC, Fragment, useEffect, useState } from 'react';
import config from 'config';
// hooks
import { useAppDispatch } from 'hooks/redux';
// Async
import PaymentsAsync from 'store/payments/paymentsAsync';
// Actions
import { reservationsActions } from 'store/reservations/reservationsSlice';
import { UiActions } from 'store/ui/uiSlice';
// mui
import { Alert, Box, Button } from '@mui/material';

interface IError {
  code:string;
  message:string;
}

type Props = {
  reservationId: number,
  onClose: () => void,
}

const PaymentCreditCardForm:FC<Props> = ({ reservationId, onClose }) => {
  const dispatch = useAppDispatch();

  const [ scriptLoaded, setScriptLoaded ] = useState(false);
  const [ errors, setErrors ] = useState<IError[]>([]);

  useEffect(() => {
    // Needed to make sync script loading and form shown
    loadingHeartlandScript(() => {
      setScriptLoaded(true)
    });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if ( scriptLoaded ){
      (window as any).GlobalPayments.configure({
        publicApiKey: config.publicApiKey // Here should be go apiKey
      });
      // Create form
      const cardForm = (window as any).GlobalPayments.creditCard.form('#credit-card');
      cardForm.on('token-success', (response:any) => {
        setErrors([]);
        const token = response.paymentReference;
        const reservationPaymentData = {
          reservationId,
          heartlandCreditCardPaymentData: {token},
        }
        dispatch(PaymentsAsync.createPayment({reservationPaymentData}))
          .unwrap()
          .then(() => {
            dispatch(reservationsActions.markAsPaidReservation(reservationId));
            dispatch(UiActions.enqueueSnackbar({ message: 'Reservation was successfully paid' }));
          })
      });
      cardForm.on('token-error', (response:any) => {
        if ( response.error ) setErrors(response.reasons);
      });
    }
    // eslint-disable-next-line
  }, [scriptLoaded]);

  if ( !scriptLoaded ) return null;
  return (
    <Fragment>
      {errors.length ? (
        errors.map((error:IError, index:number) => (
          <Alert key={`heartland-error-item-${index}`} severity="error">{error.message}</Alert>
        ))
      ) : null}
      <Box sx={{ maxWidth: '100%', pt: 2 }}>
        <form id="heartland-form" action="/Payment/Charge" method="get">
          <div id="credit-card" />
        </form>
        <Button
          fullWidth
          onClick={onClose}
          variant="outlined"
          size="large"
        >
          Cancel
        </Button>
      </Box>
    </Fragment>
  )
}

export default PaymentCreditCardForm;

const loadingHeartlandScript = (cb:() => void) => {
  const id = 'heartlandScript';
  const existedScript = document.getElementById(id);
  if ( existedScript ){
    if ( cb ) cb();
  } else {
    const script = document.createElement('script');
    script.src = 'https://api2.heartlandportico.com/SecureSubmit.v1/token/gp-1.0.1/globalpayments.js';
    script.id = id;
    document.body.appendChild(script);
    script.onload = () => { 
      if ( cb ) cb();
    };
  }
}
